import React from "react";
import Quiz from "../../images/quiz.jpeg";
import "./StdnewCardBan.css";
import { useHistory } from "react-router";
function StdNewCardBanner({ name, count, imgUrl,link }) {

  const history = useHistory()

  return (
    <div className="cardbanBox">
      <div className="cardBanImg">
        <img src={imgUrl} alt="quizImg" />
      </div>

      <div className="cardBanDesBOx">
        <div className="cardBanDes">
          <span>{name}</span>
          <small>{count}</small>
        </div>
        <div>
          {link !== '' ? (
            <button onClick={() => history.push(link)}>View Details</button>
          ) : (
            <button>View Details</button>
          )}
          
        </div>
      </div>
    </div>
  );
}
export default StdNewCardBanner;
